<template>
    <div id="app">
        <div class="modal-list" :class="{'display': !isOpenAnticipo}">
            <div>
                <h3 @click="isOpenAnticipo = false">X</h3>
                <center>
                    <h3>Generar Anticipo</h3>
                </center>
                <span v-if="modelSelected" @click="change"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div class="model-list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="200">
                        <div v-for="(model, index) in models" @click="selectModel(model, index)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                                <label for="">{{ model.type }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="modelSelected" class="anticipos">
                    <div class="model-info">
                        <h3>Información</h3>
                        <img :src="userImgselect" alt="">
                        <div>
                            <h5>{{ userNameSelect }}</h5>
                            <label for="">{{ userTypeSelect }}</label>
                        </div>
                    </div>
                    <div class="anticipos-info">
                        <h3>Agregar Ingreso</h3>
                        <div>
                            <label for="">Valor</label>
                            <input type="number" name="" id="" v-model="monto">
                        </div>
                        <div>
                            <label for="">Tipo Anticipo</label>
                            <select name="" id="" v-model="type">
                                <option v-for="(type, index) in anticiposTypes" :key="index" :value="type.name">{{ type.name }}</option>
                            </select>
                        </div>
                        <div>
                            <label for="">Medio de pago</label>
                            <select name="" id="" v-model="medio">
                                <option v-for="(medio, index) in anticiposMedios" :key="index" :value="medio.name">{{ medio.name }}</option>
                            </select>
                        </div>
                        <div>
                            <label for="">Comprobante</label>
                            <input type="file" ref="select_file_product" name="photo" @change="imgSelected = !imgSelected" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                            <button @click="$refs.select_file_product.click()"><i class="fa-solid fa-upload"></i></button>
                        </div>
                        <br>
                        <br>
                        <button @click="createAnticipo">Agregar Anticipo</button>
                    </div>
                </div>
            </div>
        </div>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="realtimeInfo" :title="this.info.name">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div class="buttos-realtime" >
                    <button v-for="(item, index) in info.platforms" :key="index" v-if="item.platform === 'Chaturbate'" @click="platform_type = item.platform">{{ item.platform }}</button>
                    <button v-for="(item, index) in info.platforms" :key="index" v-if="item.platform === 'Stripchat'" @click="platform_type = item.platform">{{ item.platform }}</button>
                    <button v-for="(item, index) in info.platforms" :key="index" v-if="item.platform === 'Camsoda'" @click="platform_type = item.platform">{{ item.platform }}</button>
                    <button v-for="(item, index) in info.platforms" :key="index" v-if="item.platform === 'Bongacams'" @click="platform_type = item.platform">{{ item.platform }}</button>
                    <button v-for="(item, index) in info.platforms" :key="index" v-if="item.platform === 'Skyprivate'" @click="platform_type = item.platform">{{ item.platform }}</button>
                </div>
                <div v-for="(item, index) in info.platforms" :key="index">
                    <div v-if="item.platform === platform_type" class="info-realtime">
                        <div>
                            <div>
                                <label for="">Porcentaje: <h2>{{ item.porcentaje }}</h2></label>
                            </div>
                            <div>
                                <label for="">Total: <h2>{{'$' + item.total }}</h2></label>
                            </div>
                            <div>
                                <label for="">Tokens: <h2>{{ item.total_token }}</h2></label>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label for="">Ususario: <h2>{{ item.user }}</h2></label>
                            </div>
                            <div>
                                <label for="">Monitor: <h2>{{ '$' + item.monitor_bono }}</h2></label>
                            </div>
                            <div>
                                <label for="">Administrador: <h2>{{ '$' + item.admin_bono }}</h2></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="info-realtime">
                        <div>
                            <div>
                                <label for="">Pendiente Jugueteria: <h2>{{'$' + info.pending_jugueteria }}</h2></label>
                            </div>
                            <div>
                                <label for="">Pendiente Variedades: <h2>{{'$' + info.pending_variedades }}</h2></label>
                            </div>
                            <div>
                                <label for="">Pendiente Egresos: <h2>{{'$' +  info.pending_egresos }}</h2></label>
                            </div>
                        </div>
                    </div>
                    <div class="info-realtime">
                        <div>
                            <div>
                                <label for="">Anticipo jugueteria: <h2>{{'$' +  info.anticipos_jugueteria }}</h2></label>
                            </div>
                            <div>
                                <label for="">Anticipo mecato: <h2>{{ '$' + info.anticipo_mecato }}</h2></label>
                            </div>
                            <div>
                                <label for="">Anticipo egresos: <h2>{{ '$' + info.anticipo_egresos }}</h2></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="users_detect" title="Perfiles sin asignar">
            <div class="info-wrapper d-flex flex-column align-items-center detects">
                <h3>Lista de perfiles sin asignar</h3>
                <div>
                    <table>
                        <thead>
                            <th>Usuario</th>
                            <th>Fecha</th>
                            <th>Tokens</th>
                            <th>Plataforma</th>
                        </thead>
                        <tbody>
                            <tr v-for="(user, index) in detectUsers" :key="index">
                                <td>{{ user.user }}</td>
                                <td>{{ user.date.split($store.state.constants.SEPARETOR)[0] }}</td>
                                <td>{{ user.tokens }}</td>
                                <td>{{ user.type }}</td>
                                <td><h4 @click="deleteUser(user.user)">X</h4></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button @click="UpdateUsers()">Actualizar lista</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="xl" ref="anticipos" :title="this.info.name">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div class="tabla">
                    <center>
                        <h3>Anticipos</h3>
                        <div>
                            <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="400">
                                <thead>
                                    <th>Fecha</th>
                                    <th>Nombre</th>
                                    <th>Valor</th>
                                    <th>Tpo</th>
                                    <th>Medio</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(anticipo, index) in anticipos" :key="index" :class="{'selectModel': anticipo.select}" v-on:click="selectAnticipo(index)">
                                        <td>{{ anticipo.created_at.split($store.state.constants.SEPARETOR)[0] }}</td>
                                        <td>{{ anticipo.to }}</td>
                                        <td>{{ anticipo.valor }}</td>
                                        <td>{{ anticipo.type }}</td>
                                        <td>{{ anticipo.medio }}</td>
                                        <td><img :src="anticipo.comprobante" alt=""></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </center>
                </div>
            </div>
        </b-modal>
        <div class="change-panel" ref="draggableContainer" @click="goTo()" :style="{'top': startY + 'px', 'left': startX + 'px'}" v-if="this.$store.getters.isCounter && this.$store.getters.isResepcionist"><img src="@/assets/change-panel.png" style="width: 50px;" /></div>
        <div class="change-panel" ref="draggableContainer" @click="$refs.users_detect.show()" :style="{'top': startYY + 'px', 'left': startXX + 'px'}" v-if="this.$store.getters.isCounter && this.$route.name !== 'recepcion'"><img src="@/assets/profile-assing.png" style="width: 50px;" /></div>
        <div class="change-panel" ref="draggableContainer" @click="isOpen = true" :style="{'top': startYYY + 'px', 'left': startXXX + 'px'}" v-if="this.$store.getters.isCounter && this.$route.name !== 'recepcion'"><img src="@/assets/realtime-nomina.png" style="width: 50px;" /></div>
        <div class="change-panel" ref="draggableContainer" @click="isOpenAnticipo = true" :style="{'top': startYYY + 'px', 'right': 100 + 'px'}" v-if="this.$route.name === 'recepcion'"><img src="@/assets/anticipo.png" style="width: 85px;" /></div>
        <div class="change-panel" ref="draggableContainer" @click="$refs.anticipos.show()" :style="{'top': startYYY + 'px', 'right': 30 + 'px'}" v-if="this.$route.name === 'recepcion'"><img src="@/assets/list-anticipos.png" style="width: 50px;" /></div>
        <div class="whatsapp">
            <div v-for="(index, wp) in wps" :key="index">
                <div class="foco" :class="{ rojo: wp.status, verde: !wp.status }"></div>
                <img :src="'@/assets/'+wp.name+'.png'" alt="">
            </div>
        </div>
        <notifications group="all" position="bottom right" class="ols-notification-wrapper" width="500">
        <template slot="body" slot-scope="props">
            <div :class="props.item.type" @click="props.close(); props.item.data.close()" style="padding:5px 10px; border-left:3px solid; cursor: pointer">
                <a class="title">{{props.item.title}}</a>
                <br>
                <br>
                <br>
                <br>
                <div v-html="props.item.text">
                </div>
                <br>
                <br>
                <br>
            </div>
        </template>
        </notifications>
        <div class="intro" v-if="intro && $route.name === 'productos'" :class="{'animation': animation}">
            <div>
                <img src="@/assets/imperium.gif" alt="">
            </div>
        </div>
        <center>
            <div v-if="isOpen === true" class="prenomina">
                <div class="close"><h4 @click="isOpen = false">X</h4></div>
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Photo</th>
                            <th>Modelo</th>
                            <th>Plataformas</th>
                            <th>Mecato</th>
                            <th>Jugueteria</th>
                            <th>Pendiente Jug</th>
                            <th>Variedades</th>
                            <th>Pendiente Var</th>
                            <th>Egresos</th>
                            <th>Pendiente Egresos</th>
                            <th>Ingresos</th>
                            <th>Bono</th>
                            <th>Total a pagar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in subnominas" :key="index" :class="{'modelo': item.user_type === 'Modelo', 'admin': item.user_type !== 'Modelo', 'no-pay': item.no_pay}">
                            <template v-if="item > 0">
                                <td colspan=13 v-if="userOpen === item" style="background-color: aquamarine;">
                                    <center>
                                        <button :class="{'active': optionSelect === 'platforms'}" @click="optionSelect='platforms'">Plataformas</button>
                                        <button :class="{'active': optionSelect === 'pendientes'}" @click="optionSelect='pendientes'">Pendientes</button>
                                        <button :class="{'active': optionSelect === 'egresos'}" @click="optionSelect='egresos'">Egresos</button>
                                        <button :class="{'active': optionSelect === 'jugueteria'}" @click="optionSelect='jugueteria'">Jugueteria</button>
                                        <button :class="{'active': optionSelect === 'variedades'}" @click="optionSelect='variedades'">Variedades</button>
                                        <button :class="{'active': optionSelect === 'mecato'}" @click="optionSelect='mecato'">Mecato</button>
                                        <button :class="{'active': optionSelect === 'ingresos'}" @click="optionSelect='ingresos'">ingresos</button>
                                        <button :class="{'active': optionSelect === 'anticipos'}" @click="optionSelect='anticipos'">Anticipos</button>
                                        <button :class="{'active': optionSelect === 'lastplatforms'}" @click="optionSelect='lastplatforms'">Ultimas ganancias</button>
                                        <table v-if="optionSelect === 'platforms'">
                                            <thead>
                                                <tr>
                                                    <th>DIA</th>
                                                    <th>Chaturbate</th>
                                                    <th>Stripchat</th>
                                                    <th>Camsoda</th>
                                                    <th>Bongacams</th>
                                                    <th>Skyprivate</th>
                                                    <th>TOTAL</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>TOTAL</td>
                                                    <td>{{ totalChaturbateLedgers }}</td>
                                                    <td>{{ totalStripchatLedgers }}</td>
                                                    <td>{{ totalCamsodaLedgers }}</td>
                                                    <td>{{ totalBongaCamsLedgers }}</td>
                                                    <td>{{ totalSkyprivateLedgers }}</td>
                                                    <td>{{ totalChaturbateLedgers + totalStripchatLedgers + totalSkyprivateLedgers + totalBongaCamsLedgers + totalCamsodaLedgers}}</td>
                                                </tr>
                                                <tr v-for="(ledger, index) in ledgers" :key="index">
                                                    <td>{{ ledger.date.split('T')[0] }}</td>
                                                    <td>{{ ledger.chaturbate }}</td>
                                                    <td>{{ ledger.stripchat }}</td>
                                                    <td>{{ ledger.camsoda }}</td>
                                                    <td>{{ ledger.bonga }}</td>
                                                    <td>{{ ledger.skyprivate }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table v-if="optionSelect === 'pendientes'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td>{{ priceFormat(totalPendings) }}</td>
                                                    <td></td>
                                                </tr>
                                                <tr v-for="(pending, index) in pendings" :key="index">
                                                    <td>{{ pending.type }}</td>
                                                    <td>{{ priceFormat(pending.valor) }}</td>
                                                    <td><h5 @click="detelePending(pending.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'pending')">Agregar Pendiente</button>
                                        </table>
                                        <table v-if="optionSelect === 'anticipos'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Medio</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalAnticipos) }}</td>
                                                </tr>
                                                <tr v-for="(anticipo, index) in anticipos" :key="index">
                                                    <td>{{ anticipo.type }}</td>
                                                    <td>{{ anticipo.medio }}</td>
                                                    <td>{{ priceFormat(anticipo.valor) }}</td>
                                                    <td><h5 @click="deteleAnticipo(anticipo.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'anticipo')">Agregar Anticipos</button>
                                        </table>
                                        <table v-if="optionSelect === 'egresos'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Motivo</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalEgresos) }}</td>
                                                </tr>
                                                <tr v-for="(egreso, index) in egresos" :key="index">
                                                    <td>{{ egreso.type }}</td>
                                                    <td>{{ egreso.motivo }}</td>
                                                    <td>{{ priceFormat(egreso.valor) }}</td>
                                                    <td><h5 @click="deleteEgreso(egreso.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'egreso')">Agregar Egreso</button>
                                        </table>
                                        <table v-if="optionSelect === 'jugueteria'">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Categoria</th>
                                                    <th>Cantidad</th>
                                                    <th>Total</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalJugueterias) }}</td>
                                                </tr>
                                                <tr v-for="(juguete, index) in jugueteria" :key="index">
                                                    <td>{{ juguete.name }}</td>
                                                    <td>{{ juguete.category }}</td>
                                                    <td>{{ juguete.cant }}</td>
                                                    <td>{{ priceFormat(juguete.total) }}</td>
                                                    <td v-if="juguete.status === 0"><h5 @click="deleteVenta(juguete.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'tienda')">Agregar Jugueteria</button>
                                        </table>
                                        <table v-if="optionSelect === 'variedades'">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Categoria</th>
                                                    <th>Cantidad</th>
                                                    <th>Total</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalVariedades) }}</td>
                                                </tr>
                                                <tr v-for="(variedad, index) in variedades" :key="index">
                                                    <td>{{ variedad.name }}</td>
                                                    <td>{{ variedad.category }}</td>
                                                    <td>{{ variedad.cant }}</td>
                                                    <td>{{ priceFormat(variedad.total) }}</td>
                                                    <td v-if="variedad.status === 0"><h5 @click="deleteVenta(variedad.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'tienda')">Agregar Variedades</button>
                                        </table>
                                        <table v-if="optionSelect === 'mecato'">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Categoria</th>
                                                    <th>Cantidad</th>
                                                    <th>Total</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalMecatos) }}</td>
                                                </tr>
                                                <tr v-for="(meca, index) in mecato" :key="index">
                                                    <td>{{ meca.name }}</td>
                                                    <td>{{ meca.category }}</td>
                                                    <td>{{ meca.cant }}</td>
                                                    <td>{{ priceFormat(meca.total) }}</td>
                                                    <td v-if="meca.status === 0"><h5 @click="deleteVenta(meca.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'tienda')">Agregar Mecato</button>
                                        </table>
                                        <table v-if="optionSelect === 'ingresos'">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Motivo</th>
                                                    <th>Valor</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>Total</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ priceFormat(totalIngresos) }}</td>
                                                </tr>
                                                <tr v-for="(egreso, index) in ingresos" :key="index">
                                                    <td>{{ egreso.type }}</td>
                                                    <td>{{ egreso.motivo }}</td>
                                                    <td>{{ priceFormat(egreso.valor) }}</td>
                                                    <td><h5 @click="deleteIngreso(egreso.id, item)">X</h5></td>
                                                </tr>
                                            </tbody>
                                            <button @click="addItem(item, 'ingreso')">Agregar Ingreso</button>
                                        </table>
                                        <table v-if="optionSelect === 'lastplatforms'">
                                            <thead>
                                                <tr>
                                                    <th>DIA</th>
                                                    <th>Chaturbate</th>
                                                    <th>Stripchat</th>
                                                    <th>Camsoda</th>
                                                    <th>Bongacams</th>
                                                    <th>Skyprivate</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="total">
                                                    <td>TOTAL</td>
                                                    <td>{{ lastTotalChaturbateLedgers }}</td>
                                                    <td>{{ lastTotalStripchatLedgers }}</td>
                                                    <td>{{ lastTotalCamsodaLedgers }}</td>
                                                    <td>{{ lastTotalBongaCamsLedgers }}</td>
                                                    <td>{{ lastTotalSkyprivateLedgers }}</td>
                                                    <td>{{ lastTotalChaturbateLedgers + lastTotalStripchatLedgers + lastTotalCamsodaLedgers + lastTotalBongaCamsLedgers + lastTotalSkyprivateLedgers}}</td>
                                                </tr>
                                                <tr v-for="(ledger, index) in lastLedgers" :key="index">
                                                    <td>{{ ledger.date.split('T')[0] }}</td>
                                                    <td>{{ ledger.chaturbate }}</td>
                                                    <td>{{ ledger.stripchat }}</td>
                                                    <td>{{ ledger.camsoda }}</td>
                                                    <td>{{ ledger.bonga }}</td>
                                                    <td>{{ ledger.skyprivate }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </center>
                                </td>
                            </template>
                            <template v-else>
                                <td>{{ index }}</td>
                                <td><img :src="item.photo" alt=""></td>
                                <td @click="openInfo(index)">{{ item.name }}</td>
                                <td>{{ priceFormat(item.platforms_ledgers + item.bono_dolar) }}</td>
                                <td>{{ priceFormat(item.mecato) }}</td>
                                <td>{{ priceFormat(item.jugueteria) }}</td>
                                <td>{{ priceFormat(((item.pending_jugueteria))) }}</td>
                                <td>{{ priceFormat(item.variedades) }}</td>
                                <td>{{ priceFormat((item.pending_variedades)) }}</td>
                                <td>{{ priceFormat(item.multas) }}</td>
                                <td>{{ priceFormat((item.pending_egresos)) }}</td>
                                <td>{{ priceFormat(item.ingresos) }}</td>
                                <td>{{ priceFormat(item.bono_pesos) }}</td>
                                <td>{{ priceFormat(parseFloat((item.bono_dolar * last_trm) + item.ingresos + parseFloat(item.bono_pesos) + parseFloat(item.platforms_ledgers * last_trm) - (parseFloat(item.jugueteria) + parseFloat(item.multas) + parseFloat(item.mecato) + parseFloat(item.variedades)))) }}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </center>
        <router-view class="app"/>
  </div>
</template>

<script>
import API from '@/api'
import Price from './utils/ConvertPriceNumber'
import Notify from '@/utils/Notification.js'

export default {
    name: 'App',
    data() {
        return {
            intro: true,
            animation: false,
            x_change: 0,
            startY: 15,
            startX: 400,
            startYY: 15,
            startXX: 500,
            startYYY: 15,
            startXXX: 600,
            name: null,
            detectUsers: [],
            isOpen: false,
            isOpenAnticipo: false,
            last_trm: null,
            nomina_id: null,
            last_finish_date: null,
            last_start_date: null,
            subnominas: [],
            info: {},
            platform_type: null,
            isCollapse: false,
            principal: false,
            anticipos: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            anticiposTypes: [],
            anticiposMedios: [],
            anticipoSelect: null,
            egreso_type: null,
            models: [],
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            searchValue: '',
            modelSelected: false,
            userIdSelect: null,
            userImgselect: null,
            userNameSelect: null,
            userTypeSelect: null,
            monto: 0,
            anticiposPicture: null,
            anticiposPictureObject: null,
            wps: []
        }
    },
    metaInfo () {
        return {
            title: '',
            titleTemplate: '',
            meta: [
                {'property': 'og:title', 'content': this.$t('apptitle')},
                {'property': 'og:image', 'content': process.env.INTERSEGUROS_IMAGEN},
                {'property': 'og:description', 'content': this.$t('appdescription')}
            ]
        }
    },
    beforeMount() {
        if (this.$route.name === 'recepcion') {
            this.name = 'Administración'
        } else {
            this.name = 'Tienda'
        }
    },
    methods: {
        getWPSinfo() {
            API.getWPSinfo()
                .then((res) => {
                    this.wps = res
                })
        },
        uploadFile() {
            this.Images = this.$refs.file.files[0]
        },
        productUpdatePhoto (id) {
            var file = this.$refs.select_file_product.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                API.Store.anticipoUpdatePhoto(this.anticiposPictureObject, id)
                    .then(result => {
                        this.getAnticipos()
                        Notify('dirty', 'Se ha cambiado la imgen del anticipo con exito')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
        },
        saveImage (file, cb) {
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                if (file.type === 'image/gif') {
                    vm.anticiposPicture = e.target.result
                    vm.anticiposPictureObject = file
                    if (cb) {
                        var toSend = {}
                        toSend.src = vm.anticiposPicture
                        cb(toSend)
                    }
                } else {
                    var image = new Image()
                    image.src = e.target.result
                    var width = 0
                    var height = 0
                    image.onload = function() {
                        width = this.width
                        height = this.height
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0)
                        var maxWidth = 400
                        var maxHeight = 400
                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height
                                height = maxHeight
                            }
                        }
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0, width, height)
                        vm.anticiposPicture = canvas.toDataURL(file.type)
                        var byteString
                        if (vm.anticiposPicture.split(',')[0].indexOf('base64') >= 0) {
                            byteString = atob(vm.anticiposPicture.split(',')[1])
                        } else {
                            byteString = unescape(vm.anticiposPicture.split(',')[1])
                        }
                        var mimeString = vm.anticiposPicture.split(',')[0].split(':')[1].split(';')[0]
                        var ia = new Uint8Array(byteString.length)
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }
                        try {
                            vm.anticiposPictureObject = new File([new Blob([ia], {type: mimeString})], file.type)
                        } catch (err) {
                            vm.anticiposPictureObject = new Blob([ia], {type: mimeString})
                            vm.anticiposPictureObject.name = file.name
                            vm.anticiposPictureObject.lastModifiedDate = new Date()
                        }

                        if (cb) {
                            cb(image)
                        }
                    }
                }
            }
            reader.readAsDataURL(file)
        },
        openInfo(index) {
            this.info = this.subnominas[index]
            this.$refs.realtimeInfo.show()
        },
        getLastNomina() {
            API.getLastNomina()
                .then((res) => {
                    this.last_trm = res.trm
                    if (res.trm === null) {
                        this.getLastTrm()
                    }
                    this.nomina_id = res.nomina_id
                    this.last_finish_date = res.finish_date
                    this.last_start_date = res.start_date
                    this.realTimeNomina()
                })
        },
        getLastTrm() {
            API.getLastTrm()
                .then((res) => {
                    this.last_trm = res.trm
                })
        },
        realTimeNomina() {
            API.getRealTimeSubnomina()
                .then((res) => {
                    this.subnominas = res
                })
        },
        priceFormat: function(value) {
            return Price(value)
        },
        UpdateUsers() {
            API.updateUsersDetects()
                .then(() => {
                    this.getUsersDetect()
                })
        },
        deleteUser(user) {
            API.deleteUserDetect(user)
                .then(() => {
                    this.getUsersDetect()
                })
        },
        getUsersDetect() {
            API.getUsersDetect()
                .then((res) => {
                    this.detectUsers = res
                })
        },
        goTo() {
            if (this.$route.name === 'recepcion') {
                this.$router.push({name: 'Nomina'})
                this.startX = 400
                this.startXX = 500
                this.startXXX = 600
            } else {
                this.$router.push({name: 'recepcion'})
                this.startX = 100
                this.startXX = 200
                this.startXXX = 300
            }
        },
        mouseup () { // remove event listener
            window.removeEventListener('mousemove', this.mousemove)
            window.removeEventListener('mouseup', this.mouseup)
        },
        mousedown (e) {
            window.addEventListener('mousemove', this.mousemove)
            window.addEventListener('mouseup', this.mouseup)
        },
        mousemove (e) {
            // new x - where is the mouse now
            const newX = e.clientX
            const newY = e.clientY
            this.startX = newX
            this.startY = newY
        },
        deleteAnticipo() {
            API.Store.deleteModelAnticipo(this.anticipoSelect)
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.anticipos = []
                    this.getAnticipos()
                    Notify('dirty', 'Se ha eliminado la multa con exito')
                })
        },
        createAnticipo() {
            var info = {
                to: this.userIdSelect,
                valor: this.monto,
                type: this.type,
                medio: this.medio
            }
            API.Store.createAnticipoByModel(info)
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.anticipos = []
                    this.isOpen = !this.isOpen
                    this.productUpdatePhoto(res.id)
                    this.userIdSelect = null
                    this.userImgselect = null
                    this.userNameSelect = null
                    this.userTypeSelect = null
                    this.modelSelected = false
                    Notify('dirty', 'Se ha creado la multa con exito')
                })
        },
        selectModel(model) {
            this.models.map(model => { model.select = false })
            model.select = true
            this.userIdSelect = model.id
            this.modelSelected = true
            this.userImgselect = model.image
            this.userNameSelect = model.name
            this.userTypeSelect = model.type
        },
        getAllModels() {
            const limit = this.searchValue === '' ? this.limitModels : 'ALL'
            const offset = this.searchValue === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.Store.getAllModelsStore(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.models = res
                    } else {
                        res.map(item => { this.models.push(item) })
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.models.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.getAllModels()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        onEnter () {
            this.searchModel()
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            }
        },
        change() {
            this.models.map(model => { model.select = false })
            this.modelSelected = !this.modelSelected
        },
        selectAnticipo(index) {
            this.anticipos.map((anticipo, i) => { if (i !== index) anticipo.select = false })
            this.anticipos[index].select = !this.anticipos[index].select
            this.anticipoSelect = this.anticipos[index].id
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.anticipos.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getAnticipos()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        getAnticipos() {
            API.Store.getAnticipos(this.limit, this.offset)
                .then((res) => {
                    if (!res) {
                        return
                    }
                    res.map(item => { this.anticipos.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        },
        getAnticiposTypes() {
            API.Store.getAnticiposTypes()
                .then((res) => {
                    this.anticiposTypes = res
                })
        },
        getAnticiposMedios() {
            API.Store.getAnticiposMedios()
                .then((res) => {
                    this.anticiposMedios = res
                })
        }
    },
    mounted() {
        setTimeout(() => {
            this.animation = true
            setTimeout(() => {
                this.intro = false
            }, 500)
        }, 4000)
        if (this.$store.getters.isSupport || this.$store.getters.isCounter) {
            this.getUsersDetect()
            this.getLastNomina()
        }
        if (this.$store.getters.isResepcionist) {
            this.getAnticipos()
            this.getAnticiposTypes()
            this.getAnticiposMedios()
        }
        this.getAllModels()
        if (this.$route.name !== 'recepcion') {
            this.startX = 400
            this.startXX = 500
            this.startXXX = 600
        } else {
            this.startX = 100
            this.startXX = 200
            this.startXXX = 300
        }
        this.$root.$on('collapse', (block) => {
            if (block) {
                this.startX = this.startX + 300
                this.startXX = this.startXX + 300
                this.startXXX = this.startXXX + 300
            } else {
                this.startX = this.startX - 300
                this.startXX = this.startXX - 300
                this.startXXX = this.startXXX - 300
            }
        })
    }
}
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

<style scoped>
.app{
  height: 90vh;
}
.cart {
  position: fixed;
  z-index: 999;
  padding: 20px;
  background-color: #e0b059;
  border-radius: 20px;
  color: white;
  width: 300px;
  text-align: center;
  cursor: pointer;
  border-style: solid;
}
.change-panel {
    position: fixed;
    z-index: 99;
    -webkit-transition: all 1s;
}
.whatsapp {
    position: fixed;
    z-index: 99;
    -webkit-transition: all 1s;
    margin-left: 45vw;
    display: flex;
    padding: 30px;
}
.whatsapp > div {
    padding: 0px 15px 0px 15px;
}
.whatsapp > div > img {
    width: 50px;
}
.foco{
  width: 18px;
  height: 18px;
  border-radius: 50%;
  animation: parpadeo 0.9s infinite;
}

/* VERDE */
.verde{
  background: #00ff4c;
  box-shadow:
    0 0 6px #00ff4c,
    0 0 14px #00ff4c,
    0 0 26px rgba(0,255,76,.6);
}

/* ROJO */
.rojo{
  background: #ff2b2b;
  box-shadow:
    0 0 6px #ff2b2b,
    0 0 14px #ff2b2b,
    0 0 26px rgba(255,43,43,.6);
}

@keyframes parpadeo{
  0%,100%{ opacity:1 }
  50%{ opacity:.25 }
}
.intro {
    background-color: #2b2926;
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: 9999999999;
}
.animation {
    animation-name: fade;
    animation-duration: 4.5s;
}
.intro > div{
    width: 100%;
    position: relative;
    height: 100vh;
}
.intro > div > img{
    width: 700px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
@keyframes fade {
  from {
    opacity: 1;
}
  to {opacity: 0;}
}

.dirty {
  border-color: #5A5 !important;
  background: #EFE !important;
  width: 100%;
}

.dirty:focus {
  outline-color: #8E8 !important;
}

.error {
  border-color: red !important;
  background: #FDD !important;
}

.error:focus {
  outline-color: #F99 !important;
}

.error-mess {
  margin-top: -1.5em;
  position: absolute;
  color: #FF0000;
}
.display{
    display: none;
}
div.modal-list {
    padding: 40px;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(43, 41, 38, 0.7);
    z-index: 99999;
    border-radius: 0px;
}
div.modal-list > div{
    background-color: #FFF;
    height: 100%;
    width: 100%;
    padding: 20px;
    color: #000;
    position: relative;
}
div.modal-list > div > button {
    position: absolute;
    top: 30px;
    background-color: #e0b059;
    color: #fff;
    width: 250px;
    height: 40px;
    border-radius: 30px;
}
div.modal-list > div > h3 {
    font-weight: bolder;
    position: absolute;
    right: 20px;
}
div.modal-list > div > span > svg {
    font-weight: bolder;
    position: absolute;
    left: 20px;
    top: 27px;
    font-size: 28px;
}
div.modal-list > div > h3:hover {
    color: red;
    cursor: pointer;
}
input[type=file] {
    display: none;
}
.anticipos-info > div {
    position: relative;
}
.anticipos-info > div > button{
    width: 50px;
    height: 50px;
    background-color: #e0b059;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, -50%);
}
div.modal-list > div > span > svg:hover {
    color: red;
    cursor: pointer;
}
div.modal-list > div > div.list{
    padding: 20px;
    height: 100%;
}
div.modal-list > div > div.list > input{
    width: 100%;
    height: 50px;
    border-radius: 20px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
}
div.modal-list > div > div.list > div.model-list{
    padding: 20px;
    overflow: auto;
    height: 80%;
    position: relative;
}
div.modal-list > div > div.list > div.model-list > div{
    width: 25%;
    display: inline-block;
}
div.modal-list > div > div.list > div.model-list > div.select {
    background-color: #63b763;
}
div.modal-list > div > div.list > div.model-list > div > div{
    padding: 20px;
    width: 100%;
    text-align: center;
}
div.modal-list > div > div.list > div.model-list > div > div > center > img{
    width: 200px;
    height: 200px;
    object-fit: cover;
}
div.modal-list > div > div.anticipos {
    width: 100%;
    height: 90%;
    display: flex;
}
div.modal-list > div > div.anticipos > div.model-info {
    width: 30%;
    height: 100%;
    text-align: center;
    padding: 20px;
    position: relative;
}
div.modal-list > div > div.anticipos > div.model-info > button{
    position: absolute;
    bottom: 30px;
    background-color: #e0b059;
    color: #fff;
    width: 250px;
    height: 40px;
    border-radius: 30px;
    left: 50%;
    transform: translate(-50%, -50%);
}
div.modal-list > div > div.anticipos > div.model-info > img {
    width: 250px;
    height: 250px;
    object-fit: cover;
    margin-top: 40px;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
}
div.modal-list > div > div.anticipos > div.model-info > div {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
}
div.modal-list > div > div.anticipos > .anticipos-info {
    padding: 40px;
    width: 100%;
    height: 100%;
    text-align: center;
}
div.modal-list > div > div.anticipos > .anticipos-info > h3{
    margin: 40px;
}
div.modal-list > div > div.anticipos > .anticipos-info > div {
    margin: 10px;
    display: grid;
    padding: 20px 100px 20px 100px;
}
div.modal-list > div > div.anticipos > .anticipos-info > div > input, div.modal-list > div > div.anticipos > .anticipos-info > div > select {
    height: 40px;
    border-style: solid;
    border-radius: 20px;
    text-align: center;
}
div.modal-list > div > div.anticipos > .anticipos-info > div > textarea {
    border-style: solid;
    border-radius: 20px;
}
div.modal-list > div > div.anticipos > .anticipos-info > button {
    margin: auto;
    margin-bottom: 0px;
    background-color: #e0b059;
    color: #fff;
    width: 50%;
    height: 40px;
    font-weight: bold;
    border-radius: 30px;
}

@media (max-width: 768px) {
  .ols-notification-wrapper {
    bottom: 0px!important;
    position: fixed!important;
    top: unset!important;
  }
  html {
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

@media screen and (max-width: 800px) {
  .ols-notification-wrapper {
    display: flex;
    width: 100% !important;
    margin-left: 0 !important;
    left: 0 !important;
    justify-content: center;
  }
  .notification-wrapper {
    font-size: 10px;
  }
  .modal-dialog {
    margin-top: 80px;
  }
}

.buttos-realtime {
        text-align: center;
    height: auto;
}
.buttos-realtime > button {
    background-color: #e0b059;
    color: #fff;
    padding: 10px;
    border-radius: 20px;
    border-color: #fff;
}
.info-realtime {
    width: 700px;
}
.info-realtime > div {
    display: flex;
    margin-top: 20px;
}
.info-realtime > div > div {
    width: 33.3333%;
    text-align: center;
}
.info-realtime > div > label {
    font-size: 28px;
}

.detects > div {
  height: 650px;
  overflow: auto;
}
.detects > button {
  background-color: #e0b059;
  margin: 20px;
  border-radius: 20px;
  border-style: solid;
  border-color: #fff;
  padding: 20px;
  color: #fff;
}
.detects > div > table > thead > th {
  padding: 20px;
}
.detects > div > table > tbody > tr > td {
  padding: 20px;
}
.detects > div > table > tbody > tr > td > h4 {
  color: red;
  font-weight: bolder;
  cursor: pointer;
  text-align: center;
}
    center >.prenomina{
    position: fixed;
    background-color: turquoise;
    z-index: 1039;
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 40px;
    border-radius: 20px;
}
    center > .prenomina > div {
    position: fixed;
    bottom: 20px;
    /* top: 20px; */
    cursor: pointer;
    width: 100%;
}
    center > .prenomina > div.close {
    position: fixed;
    top: 10px;
    right: 20px;
    cursor: pointer;
    width: 10px;
    height: 10px;
    z-index: 9999;
}
    center > .prenomina > div > button {
    color: #fff;
    background-color: #e0b059;
    padding: 20px;
    border-radius: 20px;
    border-color: #fff;
    width: 300px;
}
    center > .prenomina > table > thead > tr > th {
    padding: 10px;
    background-color: #e0b059;
    text-align: center;
    position: sticky; top: 0; z-index: 1;
    z-index: 999;
}
    center> .prenomina > table > tbody > tr.modelo {
    background-color: aqua;
}
    center> .prenomina > table > tbody > tr.no-pay {
    background-color: red;
}
    center> .prenomina > table > tbody > tr >  td {
    padding: 10px;
    text-align: center;
    border-style: inset;
}
    center> .prenomina > table > tbody > tr >  td > button {
    background-color: #e0b059;
    text-align: center;
    position: sticky; top: 0; z-index: 1;
    border-radius: 50%;
}
    center > .prenomina > table > tbody > tr > td > img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
}
    center> .prenomina > table > tbody > tr >  td > center > button {
    background-color: #e0b059;
    color: #fff;
    padding: 10px;
    border-radius: 20px;
    border-color: #fff;
}
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
th     { background:#eee; }
    center> .prenomina > table > tbody > tr >  td > center > table > button {
    background-color: #e0b059;
    color: #fff;
    padding: 10px;
    border-radius: 20px;
    border-color: #fff;
}
    center> .prenomina > table > tbody > tr >  td > center > table > thead > tr > th{
    padding: 30px;
}
    center> .prenomina > table > tbody > tr >  td > center > table > tbody > .total {
    background-color: #8363b7;
}
    center> .prenomina > table > tbody > tr >  td > center > table > tbody > tr > td{
    padding-left: 30px;
    padding-right: 30px;
}
    center> .prenomina > table > tbody > tr >  td > center > table > tbody > tr > td > h5{
    cursor: pointer;
}
    center> .prenomina > table > tbody > tr >  td > center > table > tbody > tr > td > h5:hover{
    color: red;
}
    center> .prenomina > table > tbody > tr >  td > center > .active {
    background-color: #fff;
    color: #e0b059;
    padding: 10px;
    border-radius: 20px;
    border-color: #e0b059;
}

.tabla {
        width: 100%;
        padding: 20px;
    }
    .tabla > .function {
        width: 100%;
        height: 20vh;
        padding-top: 20px;
    }
    .tabla > .function > center{
        padding: 20px;
        background-color: #63b78c;
        height: 100%;
        border-radius: 20px;
        position: relative;
    }
    .tabla > .function > center > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }
    .tabla > .function > center > div > button{
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        height: auto;
        border-radius: 30px;
        width: 200px;
        padding: 10px;
        margin-left: 15px;
        margin-right: 15px;
    }
    .tabla > center {
        height: 100%;
        background-color: #63b7a4;
        border-radius: 20px;
        padding: 50px;
        overflow-y: auto;
    }
    .tabla > center > div > table > tbody > tr.selectModel {
        background-color: #63b763;
    }
    .tabla > center > h3 {
        color: #fff;
        padding: 20px;
    }
    .tabla > center > div > table {
        margin-top: 30px;
        border-radius: 20px;
    }
    .tabla > center > div > table > thead > th {
        padding: 30px;
        border-style: double;
        background-color: #e0b059;
        width: 180px;
    }
    .tabla > center > div > table > tbody > tr {
        text-align: center;
        font-weight: bold;
        cursor: pointer;
    }
    .tabla > center > div > table > tbody > tr > td{
        border-style: solid;
        padding: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue